module.exports = __webpack_public_path__ + "static/media/mergecity-app.31ad4a0d.png";